<template>
  <v-main>
    <AppHeader app />
    <AppLeftDrawer app />
    <v-container class="pb-0">
      <v-row no-gutters>
        <v-col>
          <v-fade-transition mode="out-in">
            <router-view></router-view>
          </v-fade-transition>
        </v-col>
      </v-row>
    </v-container>
    <!-- <AppRightDrawer app /> -->
    <Offline />
    <RefreshApp />
    <SnackMessage />
  </v-main>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { NAMESPACE } from '../store'

import AppHeader from './AppHeader'
import AppLeftDrawer from './AppLeftDrawer'
// import AppRightDrawer from './AppRightDrawer'
import Offline from './Offline'
import RefreshApp from './RefreshApp'
import SnackMessage from './SnackMessage'

export default {
  props: ['nav'],
  components: {
    AppHeader,
    AppLeftDrawer,
    RefreshApp,
    SnackMessage,
    Offline
  },
  computed: {
    ...mapState(NAMESPACE, ['currentNav'])
  },
  methods: {
    ...mapActions(NAMESPACE, ['setCurrentNav']),
    ensureCurrentNav() {
      const nav = this.nav || 'default'
      if (nav !== this.currentNav) {
        this.setCurrentNav(nav)
      }
    }
  },
  beforeMount() {
    this.ensureCurrentNav()
  },
  beforeUpdate() {
    this.ensureCurrentNav()
  }
}
</script>
